import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import "./Gallery.css";
import { Link } from "react-router-dom";
import { LanguageContext } from "../../context/LanguageContext";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const Gallery = () => {
  const { currentLang } = useContext(LanguageContext);
  const [gallery, setGallery] = useState(null);

  const resolveUrl = (url) => {
    if (!url) return "";
    return url.startsWith("http") ? url : `${API_BASE}${url}`;
  };

  // ============================================================
  // FETCH GALLERY SECTION (DYNAMIC)
  // ============================================================
  useEffect(() => {
    const fetchGallery = async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/api/GallerySection?lang=${currentLang}`
        );
        setGallery(res.data);
      } catch (err) {
        console.error("Error fetching Gallery Section:", err);
      }
    };

    fetchGallery();
  }, [currentLang]);

  if (!gallery) return null;

  const galleryLinks = [
    "/warranty",
    "/serviceSupport",
    "/road-assistance",
    null,
  ];

  return (
    <section className="voyah-gallery">
      <div className="gallery-grid">

        {gallery &&
         gallery.map((item, index) => {
            const to = galleryLinks[index] ?? null;

            return (
            <div key={item.id} className="gallery-card">

              <div className="gallery-img-wrapper">
                <img src={resolveUrl(item.img)} alt={item.text} />
              </div>

              <div className="gallery-text-row">
                {to ? (
                  <Link to={to}>{item.text}</Link>
                ) : (
                  <a
                    href="#find-us"
                    onClick={(e) => e.preventDefault()}
                  >
                    Here you will find us here
                  </a>
                )}
                <span className="arrow">→</span>
              </div>

            </div>
          );
         })}

      </div>
    </section>
  );
};

export default Gallery;


// import React from "react";
// import "./Gallery.css";
// import { Link } from "react-router-dom";

// // ===== STATIC IMAGE IMPORTS =====
// import img1 from "../../assets/images/gallery/gall1.avif";
// import img2 from "../../assets/images/gallery/gall2.avif";
// import img3 from "../../assets/images/gallery/gall3.avif";
// import img4 from "../../assets/images/gallery/gall4.avif";


// const Gallery = () => {
//   // ===== STATIC DATA =====
//   const gallery = [
//     { id: 1, img: img1, text: "Read more about VOYAH Warranty" },
//     { id: 2, img: img2, text: "What do I do in case of car damage?" },
//     { id: 3, img: img3, text: "This is what you get with VOYAH Roadside Assistance"},
//     { id: 4, img: img4, text: "Here you will find us" },

//   ];

//   return (
//     <section className="voyah-gallery">
//       <div className="gallery-grid">

//         {gallery.map((item) => (
//           <div key={item.id} className="gallery-card">

//             <div className="gallery-img-wrapper">
//               <img src={item.img} alt={item.text} />
//             </div>

//             <div className="gallery-text-row">
//               <Link>{item.text}</Link>
//               <span className="arrow">→</span>
//             </div>

//           </div>
//         ))}

//       </div>
//     </section>
//   );
// };

// export default Gallery;
